var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("table", { attrs: { cellspacing: "20" } }, [
      _c("tr", [
        _c("td", { staticStyle: { width: "170px" } }, [
          _vm._v("CODIGO DE COMPROBANTE")
        ]),
        _vm._v(" "),
        _c("td", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("# " + _vm._s(_vm.value.CodigoComprobante))
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("TIPO")]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.tipo(_vm.value.Tipo)))])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("FECHA")]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.value.Fecha))])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("VENCIMIENTO")]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.value.FechaVencimiento))])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("IMPORTE")]),
        _vm._v(" "),
        _c("td", [
          _vm._v("$ " + _vm._s(_vm._f("formatMoney")(_vm.value.Importe)))
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("SALDO")]),
        _vm._v(" "),
        _c("td", [
          _vm._v("$ " + _vm._s(_vm._f("formatMoney")(_vm.value.Saldo)))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310b5ffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310b5ffa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ctacte/comprobante.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-310b5ffa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ctacte/comprobante.vue
// module chunks = 0